import { useState } from "react";
import { toast, Toaster } from "react-hot-toast";

import { InputPassword } from "../../../../components/inputs/input-password";
import { ButtonLoading } from "../../../../components/buttons/button-loading";

const initialPassValues = {
  newPass: "",
  currentPass: "",
  confirmPass: "",
};
// TODO won't work, needs to be update to use new backend endpoints
const ChangePassForm = (props) => {
  const [pass, setPass] = useState(initialPassValues);
  const [loading, setLoading] = useState(false);

  const handleResetPass = () => setPass(initialPassValues);
  const handleChange = (key, value) =>
    setPass((prevValues) => ({ ...prevValues, [key]: value }));

  const changePassword = () => {
    setLoading(true);
    // TODO: Implement backend password change endpoint
    // For now, we'll show a message that this feature is temporarily unavailable
    toast.error("El cambio de contraseña está temporalmente deshabilitado. Contacte al administrador.");
    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pass.newPass !== pass.confirmPass) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    changePassword();
  };

  return (
    <form className="gm-form" onSubmit={handleSubmit}>
      <Toaster />
      <div className="gm-form-container">
        <div className="gm-form-section">
          <div className="gm-form-section-title">Contraseña</div>
          <div className="gm-form-group gm-triple-form-group ">
            <div className="gm-input-group">
              <label htmlFor="currentPass">Contraseña Actual</label>
              <InputPassword
                className="gm-primary-input gm-pass-input"
                id="currentPass"
                name="currentPass"
                required
                value={pass.currentPass}
                onChange={(e) => handleChange("currentPass", e.target.value)}
                eyeDisabled={!pass.currentPass}
              />
              {/* <button type="button" className="gm-forget-pass" onClick={handleOpen} >¿Olvidate tu contraseña?</button> */}
            </div>
            <div className="gm-input-group">
              <label htmlFor="newPass">Contraseña Nueva</label>
              <InputPassword
                className="gm-primary-input gm-pass-input"
                id="newPass"
                required
                value={pass.newPass}
                onChange={(e) => handleChange("newPass", e.target.value)}
                eyeDisabled={!pass.newPass}
              />
              {pass.newPass.length >= 1 && pass.newPass.length < 8 && (
                <span className="gm-span-new-password">
                  Se requiere un mínimo de 8 carácteres.
                </span>
              )}
            </div>
            <div className="gm-input-group">
              <label htmlFor="confirmPass">Confirmar Contraseña</label>
              <InputPassword
                className="gm-primary-input gm-pass-input"
                id="confirmPass"
                name="confirmPass"
                value={pass.confirmPass}
                onChange={(e) => handleChange("confirmPass", e.target.value)}
                required
                eyeDisabled={!pass.confirmPass}
                invalid={pass.confirmPass && pass.newPass !== pass.confirmPass}
              />
              {pass.confirmPass && pass.newPass !== pass.confirmPass && (
                <div className="gm-invalid-input">Contraseñas no coinciden</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="gm-buttons">
        <ButtonLoading
          className="gm-primary-button"
          type="submit"
          loading={loading}
          disabled={pass.newPass.length < 8 || (pass.confirmPass && pass.newPass !== pass.confirmPass)}
          buttonLabel="Cambiar Contraseña"
        />
      </div>
    </form>
  );
};

export default ChangePassForm;
